import './UploadElement.scss'
import {useState} from "react";

class FileError extends Error {
    file: File | null

    constructor(file: File | null | undefined) {
        super()
        this.file = file || null
    }
}

const defaultAcceptedTypes = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
]

function extractFile(ev: React.DragEvent<any>, accepted?: string[]): File | undefined {
    ev.preventDefault();
    const dataTransferItems = ev.dataTransfer.items
    const dataTransferFiles = ev.dataTransfer.files
    const acceptedTypes = accepted || defaultAcceptedTypes
    if (dataTransferItems && dataTransferItems.length === 1) {
        const item = dataTransferItems[0]
        if (item.kind === "file") {
            const file = item.getAsFile()
            if (!file || acceptedTypes.indexOf(file.type) === -1) {
                throw new FileError(file)
            }
            return file
        }
    }
    if (dataTransferFiles && dataTransferFiles.length === 1) {
        const file = dataTransferFiles.item(0)
        if (!file || acceptedTypes.indexOf(file.type) === -1) {
            throw new FileError(file)
        }
        return file
    }
    return undefined
}

interface UploadElementProps {
    formatsString?: string
    acceptedTypes?: string[]
    framed?: boolean
    invalid?: boolean
    value?: File | undefined
    upload: (file: File) => Promise<any>
    fileError: (file: File | undefined) => Promise<any>
}

function UploadElement({
                           formatsString,
                           acceptedTypes,
                           framed,
                           value,
                           upload,
                           invalid,
                           fileError
                       }: UploadElementProps) {
    const [uploading, setUploading] = useState(false)
    const types = (acceptedTypes || defaultAcceptedTypes)

    async function internalUpload(file: File | undefined | null) {
        if (file) {
            setUploading(true)
            try {
                await upload(file)
            } finally {
                setUploading(false)
            }
        }
    }

    return <div className={`cmp-upload-element ${framed ? 'framed' : ''}`}>
        <label
            className="notification is-info is-light dnd-area"
            onDrop={async ev => {
                try {
                    const file = extractFile(ev, types)
                    await internalUpload(file)
                } catch (e: any) {
                    if (e.file || e.file === null) {
                        await fileError(e.file)
                    }
                }
            }}
            onDragOver={ev => {
                ev.preventDefault();
            }}
        >
            <div style={{fontWeight: 'bold', color: invalid ? 'red' : 'black'}}>
                {`${value ? value.name : 'Datei hinzufügen'}`}
            </div>
            <div>
                Zulässige Dateiformate: {formatsString || 'xlsx, xls'}
                <input
                    type={"file"}
                    name="file"
                    accept={types.join(',')}
                    style={{display: 'none'}}
                    onChange={async e => {
                        const files = e.target.files
                        if (files && files.length === 1) {
                            const file = files[0]

                            if (!file || types.indexOf(file.type) === -1) {
                                await fileError(file)
                                return
                            }
                            await internalUpload(file)
                            e.target.value = ''
                        }
                    }}
                />
            </div>

        </label>
        {uploading && <div className={"loading-mask notification is-info is-light"}>
            <div className={"button is-loading"}></div>
        </div>}
    </div>
}

export {
    UploadElement
}
